import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Tabs } from "antd";
import useModuleContext from "../../hooks/useModuleContext";
import DietStrategy from "../dietStrategy";
import WeightGainProjection from "./weightGainProjection";

const WeightStrategy = () => {
  const { isAllowedFunctions } = useModuleContext();
  const translation = useSelector((state) => state.app.translation);

  const [tabSelected, setTabSelected] = useState(
    isAllowedFunctions(["DIET_STRATEGY"]) ? "1" : "2"
  );

  return (
    <Tabs type="card" activeKey={tabSelected} onTabClick={setTabSelected}>
      {isAllowedFunctions(["DIET_STRATEGY"]) && (
        <Tabs.TabPane
          tab={translation.weightStrategy.tabs.dietStrategy}
          key="1"
        >
          <DietStrategy />
        </Tabs.TabPane>
      )}
      <Tabs.TabPane
        tab={translation.weightStrategy.tabs.weightGainProjection}
        key="2"
      >
        <WeightGainProjection />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default WeightStrategy;
